import { PathConfigurationService } from './../../../data/services/path-configuration'
import { PathConfiguration } from './../../../data/models/path-configuration'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'
import { IEntityMappingConfig } from '../../..'

export const PathConfigurationConfig: IDataServiceConfig<PathConfiguration> = {
  service: PathConfigurationService,
  deps: [ModelRepository],
  endpoint: 'lms/syllabus_configurations?filter[user-id]=:user_id',
  model: PathConfiguration,
  presenter: null,
  backend: 'cached',
  mappings: [
    {
      classType: 'PathConfiguration',
      jsonType: 'syllabus-configurations',
      propertyMapping: {
        rootMenuItem: {
          type: 'MenuItem',
          mapsTo: 'menu-item'
        },
        rootPathNode: {
          type: 'PathNode',
          mapsTo: 'syllabus-node'
        },
        experienceType: {
          type: 'string',
          mapsTo: 'experience_type'
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/path-configuration.config.ts